var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex justify-between"},[_c('p',{staticClass:"header"},[_vm._v("动态列表")])])])}]
render._withStripped = true
export { render, staticRenderFns }